import { IApiPhotoRequestsResult } from 'affiny-core/modules/api/models/photoRequests';
import { paginatedRequest } from 'affiny-core/modules/helpers';
import { EAffinyEventOrigin } from '../affiny.eventorigins';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const PhotoRequestsResource = {
  getPhotoRequests: (accountId: string, pageNumber: number, pageSize: number) =>
    paginatedRequest<IApiPhotoRequestsResult>({
      apiEndPoint: AffinyEndpoint.PhotoRequests.url(`/${accountId}/`),
      pageNumber,
      pageSize,
    }),
  postPhotoRequest: (receiverId: string) =>
    AffinyEndpoint.PhotoRequests.url(`/${receiverId}/`)
      .headers({ 'X-Event-Origin': EAffinyEventOrigin.W_VIEW_R })
      .post()
      .res(),
};
